import { CircleAlert, CircleCheck } from 'lucide-react';

import { Separator } from '@/components/shadcn/ui/separator';
import { NotificationChannel } from '@/entities/notification';
import useWorkspaceStore from '@/stores/WorkspaceStore';

import { useSubscription2Context } from './SubscriptionContextProvider';

const ActionBox = () => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const context = useSubscription2Context();
  const { state, setValue } = context.actionState;
  const validated = context.actionValidated;

  return (
    <div className="flex flex-col gap-4 rounded-md border p-6">
      <div className="flex items-center gap-2">
        {validated.validated ? (
          <CircleCheck className="size-5 text-green-500" />
        ) : (
          <CircleAlert className="size-5 text-amber-500" />
        )}
        <span className="text-sm font-semibold">Action</span>
        {!validated.validated && (
          <span className="text-sm text-muted-foreground">{validated.message}</span>
        )}
      </div>
      <Separator />
      <div className="flex items-center gap-5">
        <div className="w-[120px]">
          <span className="text-sm font-semibold text-muted-foreground">Integrate</span>
        </div>
        <NotificationChannel
          value={state.channel}
          onChange={(channel) => setValue('channel', channel)}
          workspaceId={currWorkspace?.alias ?? ''}
        />
      </div>
    </div>
  );
};

export default ActionBox;
